enum MetaEnum {
  'blog.blog_title' = 'blog.blog_title',
  'blog.blog_description' = 'blog.blog_description',
  'blog.blog_keywords' = 'blog.blog_keywords',
  'blog.blog_subject' = 'blog.blog_subject',
  'blog.blog_category' = 'blog.blog_category',
  'blog.blog_og_title' = 'blog.blog_og_title',
  'blog.blog_subtitle' = 'blog.blog_subtitle',
  'blog.blog_og_description' = 'blog.blog_og_description',
  'blog.blog_twitter_description' = 'blog.blog_twitter_description',
  'authors.authors_page_title' = 'authors.authors_page_title',
  'authors.authors_page_description' = 'authors.authors_page_description',
  'authors.authors_page_keywords' = 'authors.authors_page_keywords',
  'authors.authors_page_subject' = 'authors.authors_page_subject',
  'authors.authors_page_category' = 'authors.authors_page_category',
  'authors.authors_page_og_title' = 'authors.authors_page_og_title',
  'authors.authors_page_subtitle' = 'authors.authors_page_subtitle',
  'authors.authors_page_og_description' = 'authors.authors_page_og_description',
  'authors.authors_page_twitter_title' = 'authors.authors_page_twitter_title',
  'authors.authors_page_twitter_description' = 'authors.authors_page_twitter_description',
  'single_author.author_profile_title' = 'single_author.author_profile_title',
  'single_author.author_profile_description' = 'single_author.author_profile_description',
  'single_author.author_profile_keywords' = 'single_author.author_profile_keywords',
  'single_author.author_profile_subject' = 'single_author.author_profile_subject',
  'single_author.author_profile_category' = 'single_author.author_profile_category',
  'single_author.author_profile_og_title' = 'single_author.author_profile_og_title',
  'single_author.author_profile_subtitle' = 'single_author.author_profile_subtitle',
  'single_author.author_profile_og_description' = 'single_author.author_profile_og_description',
  'single_author.author_profile_twitter_title' = 'single_author.author_profile_twitter_title',
  'single_author.author_profile_twitter_description' = 'single_author.author_profile_twitter_description',
  'sign_in.sign_in_spiritory' = 'sign_in.sign_in_spiritory',
  'sign_in.sign_in_description' = 'sign_in.sign_in_description',
  'sign_in.sign_in_keywords' = 'sign_in.sign_in_keywords',
  'sign_in.sign_in_to_your_account_in_spiritory' = 'sign_in.sign_in_to_your_account_in_spiritory',
  'sign_up.sign_up_title' = 'sign_up.sign_up_title',
  'sign_up.sign_up_description' = 'sign_up.sign_up_description',
  'sign_up.sign_up_keywords' = 'sign_up.sign_up_keywords',
  'sign_up.sign_up_call_to_action' = 'sign_up.sign_up_call_to_action',
  'verify_email.verify_email_title' = 'verify_email.verify_email_title',
  'verify_email.verify_email_description' = 'verify_email.verify_email_description',
  'verify_email.verify_email_keywords' = 'verify_email.verify_email_keywords',
  'verify_email.verify_email_call_to_action' = 'verify_email.verify_email_call_to_action',
  'reset_password.reset_password_title' = 'reset_password.reset_password_title',
  'reset_password.reset_password_description' = 'reset_password.reset_password_description',
  'reset_password.reset_password_keywords' = 'reset_password.reset_password_keywords',
  'reset_password.reset_password_call_to_action' = 'reset_password.reset_password_call_to_action',
  'forgot_password.forgot_password_title' = 'forgot_password.forgot_password_title',
  'forgot_password.forgot_password_description' = 'forgot_password.forgot_password_description',
  'forgot_password.forgot_password_keywords' = 'forgot_password.forgot_password_keywords',
  'forgot_password.forgot_password_call_to_action' = 'forgot_password.forgot_password_call_to_action',
  'onboarding_buyer.personal_information.title' = 'onboarding_buyer.personal_information.title',
  'onboarding_buyer.personal_information.description' = 'onboarding_buyer.personal_information.description',
  'onboarding_buyer.personal_information.keywords' = 'onboarding_buyer.personal_information.keywords',
  'onboarding_buyer.payment_method.title' = 'onboarding_buyer.payment_method.title',
  'onboarding_buyer.payment_method.description' = 'onboarding_buyer.payment_method.description',
  'onboarding_buyer.payment_method.keywords' = 'onboarding_buyer.payment_method.keywords',
  'onboarding_buyer.business_information.title' = 'onboarding_buyer.business_information.title',
  'onboarding_buyer.business_information.description' = 'onboarding_buyer.business_information.description',
  'onboarding_buyer.business_information.keywords' = 'onboarding_buyer.business_information.keywords',
  'onboarding_buyer.finish.title' = 'onboarding_buyer.finish.title',
  'onboarding_buyer.finish.description' = 'onboarding_buyer.finish.description',
  'onboarding_buyer.finish.keywords' = 'onboarding_buyer.finish.keywords',
  'onboarding_seller.personal_information.title' = 'onboarding_seller.personal_information.title',
  'onboarding_seller.personal_information.description' = 'onboarding_seller.personal_information.description',
  'onboarding_seller.personal_information.keywords' = 'onboarding_seller.personal_information.keywords',
  'onboarding_seller.shipping_policy.title' = 'onboarding_seller.shipping_policy.title',
  'onboarding_seller.shipping_policy.description' = 'onboarding_seller.shipping_policy.description',
  'onboarding_seller.shipping_policy.keywords' = 'onboarding_seller.shipping_policy.keywords',
  'onboarding_seller.payout.title' = 'onboarding_seller.payout.title',
  'onboarding_seller.payout.description' = 'onboarding_seller.payout.description',
  'onboarding_seller.payout.keywords' = 'onboarding_seller.payout.keywords',
  'onboarding_seller.business_information.title' = 'onboarding_seller.business_information.title',
  'onboarding_seller.business_information.description' = 'onboarding_seller.business_information.description',
  'onboarding_seller.business_information.keywords' = 'onboarding_seller.business_information.keywords',
  'onboarding_seller.finish.title' = 'onboarding_seller.finish.title',
  'onboarding_seller.finish.description' = 'onboarding_seller.finish.description',
  'onboarding_seller.finish.keywords' = 'onboarding_seller.finish.keywords',
  'onboarding_index.title' = 'onboarding_index.title',
  'onboarding_index.description' = 'onboarding_index.description',
  'home.title' = 'home.title',
  'home.description' = 'home.description',
  'home.keywords' = 'home.keywords',
}

export { MetaEnum };